import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "frame"]
  static values = { src: String }

  open(event) {
    if (this.hasDialogTarget && this.dialogTarget.open) return

    if (this.hasFrameTarget) {
      this.frameTarget.innerHTML = `
        <div class="p-12 flex flex-col items-center justify-center gap-3 text-gray-400">
          <svg class="animate-spin h-8 w-8" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <span class="text-sm">Loading results…</span>
        </div>`
      this.frameTarget.setAttribute('src', this.srcValue)
    }
    if (this.hasDialogTarget) {
      this.dialogTarget.showModal()
    }
  }

  close(event) {
    if (event) event.preventDefault()
    if (this.hasDialogTarget) {
      this.dialogTarget.close()
    }
    if (this.hasFrameTarget) {
      this.frameTarget.removeAttribute('src')
      this.frameTarget.innerHTML = ''
    }
  }
}
